export default __webpack_public_path__ + "static/media/typical-icon.14f4fef4.svg";